import { ReactElement } from 'react';

import { QueueUploadGridParam } from './params/QueueUploadGridParam';
import { QueueGeopostLayerItemActions } from '../geopostLayer/QueueGeopostLayerItemActions';
import { IItemActionsProps, QueueTypeHandler } from '../QueueTypeHandler';

export class UploadGridHandler extends QueueTypeHandler {
    readonly extensionsAccepted: readonly string[] = [];

    renderParams(): ReactElement {
        return <QueueUploadGridParam />;
    }

    renderItemActions(_props: IItemActionsProps): ReactElement {
        return <QueueGeopostLayerItemActions />;
    }
}
